import React from 'react';
import PropTypes from 'prop-types';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { WN_LOAD_TAGS } from '@configuratorware/configurator-frontendgui/App/Reducers/ImageGallery/Actions';
import { createBackgroundWorkStateSelector } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Selectors';

import { withCanvasState, withCanvas } from 'redhotmagma-graphics-editor/CanvasInterface/CanvasProvider';
import {
  getSelectedDesignAreaProperties,
  getDesignDataForFilteredDesignAreas,
  hasLastEditedDesignArea,
} from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import {
  getDesignerOptionRefs,
} from '../../../Reducers/CustomDesignReducer/Selectors';
import AddVisualElement from '../Components/AddVisualElement';
import { setDesignerMobileProductListOpen, setDesignerMobileModalContent } from '../../../Reducers/CustomDesignReducer/Actions';
import Progress from '../../../Shared/Components/Progress/Progress';

class AddVisualElementContainer extends React.Component {
    static propTypes = {
      deselectImage: PropTypes.func,
      imageGallery: PropTypes.object,
      canvas: PropTypes.object,
      selectedObject: PropTypes.object,
      AddVisualElementComponent: PropTypes.func,
      loading: PropTypes.bool,
      autoHide: PropTypes.bool,
      hasLastEditedDesignArea: PropTypes.bool,
    };

    static defaultProps = {
      autoHide: false,
    };

    openAddImagePanel = async () => {
      const { canvas } = this.props;
      Services.designer.openImageEditDialog(null, canvas);
    };

    render() {
      const {
        canvas, autoHide, selectedObject, AddVisualElementComponent, loading,
      } = this.props;

      if (autoHide && selectedObject) {
        return null;
      }
      return (
        <>
          <AddVisualElementComponent
            boxed
            onAddImageClick={this.openAddImagePanel}
            onAddTextClick={() => {
              Services.designer.addText(canvas, t('addVisualElement.initialText'));
            }}
            {...this.props}
          />
          <Progress loading={loading} />
        </>
      );
    }
}

export const AddVisualElementContainerWithCanvasState = withCanvas(
  withCanvasState(AddVisualElementContainer),
);

const getLoadingState = createBackgroundWorkStateSelector(WN_LOAD_TAGS);

const mapStateToProps = (state) => {
  const { imageGallery } = state;
  const {
    filteredDesignAreas,
    maxColorAmount: maxColorAmountSource,
    designProductionMethod,
    selectedDesignArea,
  } = getSelectedDesignAreaProperties(state);
  const hasDesign = getDesignDataForFilteredDesignAreas(state);

  return {
    Component: AddVisualElementContainerWithCanvasState,
    AddVisualElementComponent: AddVisualElement,
    boxed: true,
    designAreas: filteredDesignAreas || [],
    designedAreas: hasDesign || {},
    imageGallery,
    selectedDesignArea,
    doDisplayMobile: /* isMobileDevice() && */ state.customDesignerData.designerMobileProductsListOpen,
    loading: getLoadingState(state.ui),
    imageDialogOpen: !!state.ui.visibilityMap.imageEditDialog,
    hasLastEditedDesignArea: hasLastEditedDesignArea(state.designArea),
    handleChangeDesignArea: (value) => Services.designData.selectDesignArea(value),
    valueProductionMethod: designProductionMethod,
    closeDesignArea: () => Services.designData.clearDesignAreaSelection(),
    optionRefs: getDesignerOptionRefs(state),
    handleChangeProductionMethod: (value) => {
      Services.designData.setDesignProductionMethod(value);
      Services.configurator.resolveCalculationErrors();
    },
    modalContentOptions: state.customDesignerData.designerMobileModalContentOptions,
    currentModalContentOption: state.customDesignerData.designerMobileModalContent,
  };
};
const mapDispatchToProps = (dispatch) => ({
  setModalContentOption: (value) => {
    dispatch(setDesignerMobileModalContent(value));
  },
  setDisplayDesignerMobilePicker: (value) => {
    dispatch(setDesignerMobileProductListOpen(!!value));
  },
});
export default containerConnect(mapStateToProps, mapDispatchToProps);
